/**
 * Theme state lives on <html data-theme>, which public/theme.js — loaded in the
 * document head — has already set from localStorage (dark when nothing is saved)
 * before first paint. This module only reads and flips it: it never has to apply
 * a theme on mount, which is what would cause a flash.
 */
export type Theme = 'light' | 'dark';

const KEY = 'bms-theme';

export const getTheme = (): Theme =>
  document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light';

export function setTheme(theme: Theme) {
  document.documentElement.dataset.theme = theme;
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    /* private mode: the choice just won't survive a reload */
  }
}

/** True while the user has never chosen, i.e. we are following the OS. */
export function followingSystem(): boolean {
  try {
    return !localStorage.getItem(KEY);
  } catch {
    return true;
  }
}
